import { Modal } from "react-bootstrap";
import AddCompany from "../add-company";

const AddCompanyModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
      fullscreen
      centered
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        style={{ borderBottom: "none", backgroundColor: "black" }}
      ></Modal.Header>

      <Modal.Body style={{ backgroundColor: "black", padding: 0 }}>
        <AddCompany closeModal={handleClose} />
      </Modal.Body>
    </Modal>
  );
};

export default AddCompanyModal;
